<template>
  <form v-clickOutside="vCloseEvent" @submit.prevent="vLaunchResearch">
    <div id="main-research">

      <div class="main-research-container">
        <div class="more" @click="toggleAdvanced = !toggleAdvanced">
          <span class="more-libelle">{{$_('advanced_research')}}</span>
          <span>
            <img v-bind:class="{rotate: toggleAdvanced}" src="../assets/img/arrow-down.png" />
          </span>
        </div>
        <div class="search-field">
          <input
            type="text"
            :placeholder="$_('research')"
            @input="vData('frech_lib', $event.target.value)"
          />
          <button class="btn-search">
            <img src="../assets/img/search-icon.png" />
          </button>
        </div>
      </div>
      <div class="filter-tag-container">
        <FilterTag @filter:remove="vLaunchResearch" />
      </div>
    </div>
    <transition name="slidebottom">
      <div class="advanced-main-research" v-show="toggleAdvanced">
        <div class="advanced-research">
          <SelectMultiple
            :placeholder="$_('offer_type')"
            :data="aOffer"
            :countref="5"
            :reference="'offer_type'"

            :uncheck="getCurrentDelete"
         
            :itemoption="['TCCAT', 'TLIB_CAT']"
            @selectmultiple:select="vData('ftyp_offre', $event)"
            @selectmultiple:selecting="vTag('ftyp_offre', $event)"
            :resetselect="resetvalue.reset_ftyp_offre"
          />
          <SelectMultiple
            :placeholder="$_('materials')"
            :data="aMaterial"
            :countref="40"
            :reference="'fmotc_mat'"

            :uncheck="getCurrentDelete"
           
            :itemoption="['TMOTCLE', 'TMOTCLE']"
            @selectmultiple:select="vData('fmotc_mat', $event)"
            @selectmultiple:selecting="vTag('fmotc_mat', $event)"
            :resetselect="resetvalue.reset_fmotc_mat"
          />
          <SelectMultiple
            :placeholder="$_('category')"
            :preselected="getCategory"
            :data="aCategory"
            :countref="40"
            :itemoption="['TMOTCLE', 'TMOTCLE']"
            :reference="'fmotc_cat'"

            :uncheck="getCurrentDelete"
           
            @selectmultiple:select="vData('fmotc_cat', $event)"
            @selectmultiple:selecting="vTag('fmotc_cat', $event)"
            :resetselect="resetvalue.reset_fmotc_cat"
          />
          <SelectMultiple
            :placeholder="$_('typology')"
            :data="aType"
            :countref="40"
            :itemoption="['TMOTCLE', 'TMOTCLE']"
            :reference="'fmotc_typ'"

            :uncheck="getCurrentDelete"
       
            @selectmultiple:select="vData('fmotc_typ', $event)"
            @selectmultiple:selecting="vTag('fmotc_typ', $event)"
            :resetselect="resetvalue.reset_fmotc_typ"
          />
          <SelectMultiple
            :placeholder="$_('color')"
            :data="aColor"
            :countref="10"
            :itemoption="['TCCOL', 'TLIB_CCOL']"
            :reference="'fgrp_col'"

            :uncheck="getCurrentDelete"
          
            @selectmultiple:select="vData('fgrp_col', $event)"
            @selectmultiple:selecting="vTag('fgrp_col', $event)"
            :resetselect="resetvalue.reset_fgrp_col"
          />
          <SelectMultiple
            :placeholder="$_('esthetic_characteristics')"
            :countref="40"
            :itemoption="['TMOTCLE', 'TMOTCLE']"
            :reference="'fmotc_cae'"

            :uncheck="getCurrentDelete"
         
            @selectmultiple:select="vData('fmotc_cae', $event)"
            @selectmultiple:selecting="vTag('fmotc_cae', $event)"
            :data="aEsthetic"
            :resetselect="resetvalue.reset_fmotc_cae"
          />
          <SelectMultiple
            :placeholder="$_('functional_characteristics')"
            :countref="40"
            :itemoption="['TMOTCLE', 'TMOTCLE']"
            :reference="'fmotc_caf'"

            :uncheck="getCurrentDelete"
          
            @selectmultiple:select="vData('fmotc_caf', $event)"
            @selectmultiple:selecting="vTag('fmotc_caf', $event)"
            :data="aFonctionnal"
            :resetselect="resetvalue.reset_fmotc_caf"
          />
        </div>
        <div class="button-container">
          <button class="btn-research" @click="vReinit">{{$_('reset_all')}}</button>
          <button class="btn-research" @click="vLaunchResearch">{{$_('launch_research')}}</button>
        </div>
      </div>
    </transition>
  </form>
</template>

<script>
import SelectMultiple from "@/common/components/widget/SelectMultiple";
import FilterTag from "@/modules/recherche/components/FilterTag";
import searchService from "@/modules/recherche/services/searchService";

import { Bus } from "@/common/Bus.js";

export default {
  name: "MainResearch",
  data() {
    return {
      toggleAdvanced: false,
      result: {
        aType: Array(),
        aCategory: Array(),
        aMaterial: Array(),
        aFonctionnal: Array(),
        aEsthetic: Array(),
        aOffer: Array(),
        aColor: Array(),
        nb_total: ""
      },
      resetvalue: {
        reset_ftyp_offre: false,
        reset_fmotc_mat: false,
        reset_fmotc_cat: false,
        reset_fmotc_typ: false,
        reset_fgrp_col: false,
        reset_fmotc_cae: false,
        reset_fmotc_caf: false
      }
    };
  },
  directives: {
    clickOutside: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (
            !(el == event.target || el.contains(event.target)) &&
            event.target.parentNode !== null &&
              event.target.parentNode.className !== "active"
          ) {
            vnode.context[binding.expression](event);
            vnode.context.toggleAdvanced = false;
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
        document.body.addEventListener("touchstart", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
        document.body.removeEventListener("touchstart", el.clickOutsideEvent);
      },
      stopProp(event) {
        event.stopPropagation();
      }
    }
  },
  methods: {
    vLaunchResearch() {
      if (this.$route.name !== "searchresult") {
        this.$router.push({ name: "searchresult" });
      }
      this.vData("launch_research", true);
      this.vData("reset_product_list", true);
      this.toggleAdvanced = false;
    },
    vReinit() {
      this.resetvalue.reset_ftyp_offre = true;
      this.resetvalue.reset_fmotc_mat = true;
      this.resetvalue.reset_fmotc_cat = true;
      this.resetvalue.reset_fmotc_typ = true;
      this.resetvalue.reset_fgrp_col = true;
      this.resetvalue.reset_fmotc_cae = true;
      this.resetvalue.reset_fmotc_caf = true;

      this.$store.dispatch("recherche/RESET_STATE", { reset: true });
    },
    vData(key, value) {
      this.$store.dispatch("recherche/SELECT", { key, value });
    },
    vTag(key, value) {
      this.$store.dispatch("recherche/TAG_FILTER", { value });
    },
    vCloseEvent() {},
  },
  created() {
    searchService.getType().then(res => {
      this.result.aType = res.data.DS_O.OUT;
    });
    searchService.getCategory().then(res => {
      this.result.aCategory = res.data.DS_O.OUT;
    });
    searchService.getMaterial().then(res => {
      this.result.aMaterial = res.data.DS_O.OUT;
    });
    searchService.getFonctionnal().then(res => {
      this.result.aFonctionnal = res.data.DS_O.OUT;
    });
    searchService.getEsthetic().then(res => {
      this.result.aEsthetic = res.data.DS_O.OUT;
    });
    searchService.getOffer().then(res => {
      this.result.aOffer = res.data.DS_O.OUT;
    });
    searchService.getColor().then(res => {
      this.result.aColor = res.data.DS_O.OUT;
    });

    Bus.$on("resetforcollection", () => {
      this.resetvalue.reset_ftyp_offre = true;
      this.resetvalue.reset_fmotc_mat = true;
      this.resetvalue.reset_fmotc_typ = true;
      this.resetvalue.reset_fgrp_col = true;
      this.resetvalue.reset_fmotc_cae = true;
      this.resetvalue.reset_fmotc_caf = true;
    });

    this.resetvalue.reset_ftyp_offre = false;
    this.resetvalue.reset_fmotc_mat = false;
    this.resetvalue.reset_fmotc_typ = false;
    this.resetvalue.reset_fgrp_col = false;
    this.resetvalue.reset_fmotc_cae = false;
    this.resetvalue.reset_fmotc_caf = false;
  },
  computed: {
    aType() {
      return this.result.aType;
    },
    aCategory() {
      return this.result.aCategory;
    },
    aMaterial() {
      return this.result.aMaterial;
    },
    aFonctionnal() {
      return this.result.aFonctionnal;
    },
    aEsthetic() {
      return this.result.aEsthetic;
    },
    aOffer() {
      return this.result.aOffer;
    },
    aColor() {
      return this.result.aColor;
    },
    getCategory() {
      return this.$store.getters["recherche/get_fmotc_cat_preselected"];
    },
    getCurrentDelete() {
      return this.$store.getters['recherche/get_current_filter_tag_remove'];
    }
  },
  components: {
    SelectMultiple,
    FilterTag
  }
};
</script>

<style scoped>
form {
  width: 100%;
}
#main-research {
  display: flex;
  width: 100%;
  padding: 15px 40px;
  height: 100%;
  flex-direction: column;
  flex: 1;
}
.more {
  max-width: 130px;
  display: flex;
  padding: 0px 20px 0px 0px;
  align-items: center;
}
.search-field {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.search-field input[type="text"] {
  width: 100%;
  background-color: #f5f5f5;
  border: none;
}
.search-field input[type="text"]::placeholder {
  color: #5f5f5f;
  font-style: normal;
}
.more-libelle {
  font-size: var(--fz-md);
  color: #5f5f5f;
}
.more img {
  width: 12px;
  transition: all 0.3s;
}
.more:hover {
  cursor: pointer;
}
.btn-search {
  background-color: #f00b35;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  width: 37px;
}
.btn-search img {
  width: 13px;
}
.slidebottom-enter-active,
.slidebottom-leave-active {
  transition: all 0.3s;
}
.slidebottom-enter,
.slidebottom-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
.rotate {
  transform: rotate(180deg);
}
/** RECHERCHE AVANCÉ **/
.advanced-main-research {
  position: absolute;
  z-index: 200;
  border-right: solid 1px #e9e9e9;
  border-top: solid 1px #e9e9e9;
  border-bottom: solid 1px #e9e9e9;
  width: 100%;
  padding: 15px;
  left: 0;
  background-color: #f5f5f5;
}
.advanced-research {
  display: flex;
  flex-wrap: wrap;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
.button-container button {
  margin-left: 10px;
}
.search-code-color {
  height: 38px;
  min-width: 320px;
  margin: 10px;
}
.main-research-container {
  display: flex;
  align-items: center;
}
.filter-tag-container {
  padding-top: 15px;
}
@media (max-width: 800px) {
  .advanced-main-research {
    padding: 10px 10px;
  }

  /deep/ .select-box {
    width: 100%;
  }

  .button-container {
    margin-top: 15px;
    padding: 10px;
  }
  .button-container button {
    width: 100%;
  }
}

@media (min-width: 340px) {
  #main-research {
    border-top: solid 1px #e9e9e9;
    padding: 15px 15px;
  }
}
</style>